// Per-suburb FAQ generator.
// Produces 5 Q&A pairs that mix templated questions (Google is fine with this for FAQ schema)
// with suburb-specific data (postcode, region, focus service, common fixes).
// Used by SuburbDetail.jsx to render a visible FAQ section AND emit FAQPage JSON-LD.

import { services } from "./content";

const REGION_RESPONSE = {
  "North": "On-site appointments are available across the North-side corridor (Salisbury, Mawson Lakes and surrounds), subject to availability.",
  "East & Hills": "On-site appointments are available across the East-side, Foothills and Hills suburbs, subject to availability.",
  "South": "On-site appointments are available across our southern service area, subject to availability. Not sure if we cover your suburb? Give us a call to discuss your location.",
  "West & CBD": "On-site appointments are available across the West, CBD and beach-side suburbs, subject to availability.",
}

export function getSuburbFaqs(s) {
  const focus = services.find((x) => x.slug === s.focus) || services[0];
  const firstFix = (s.commonFixes && s.commonFixes[0]) || "your computer issue";
  const secondFix = (s.commonFixes && s.commonFixes[1]) || "your home network";

  return [
    {
      q: `How quickly can a Tech Emergency technician get to ${s.name}?`,
      a: `${REGION_RESPONSE[s.region] || "On-site appointments are available across our Adelaide service area, subject to availability."} Call 1800 836 390 and we'll tell you upfront on the phone what's realistic before you book.`,
    },
    {
      q: `Is there a call-out fee for visits to ${s.name} ${s.postcode}?`,
      a: `No upfront call-out fee. We give you free over-the-phone triage on 1800 836 390 first, then a fixed, upfront quote before any technician arrives at your door in ${s.name}. You only pay when work is actually done.`,
    },
    {
      q: `What are the most common tech jobs you do in ${s.name}?`,
      a: `In ${s.name} (${s.postcode}), common call-outs include ${focus.title.toLowerCase()}, plus jobs like ${firstFix.toLowerCase()} and ${secondFix.toLowerCase()}, and similar on-site computer-repair and home-network troubleshooting. Every visit comes with a free over-the-phone triage on 1800 836 390 first, so we can tell you if it even needs a visit.`,
    },
    {
      q: `What hours can I book a ${s.name} home or business visit?`,
      a: `Monday to Saturday, 9:00 AM – 7:00 PM. We're closed Sunday. For genuine after-hours emergencies (ransomware, breached account, scam in progress) call 1800 836 390 — we'll triage on the phone and tell you honestly whether it can wait until morning.`,
    },
    {
      q: `What if the problem isn't fixed after the visit?`,
      a: `Every job we attend in ${s.name} carries our No Fix · No Fee guarantee — if we can't resolve it, you don't pay for our labour. We also back our work with a 7-day warranty on labour. Replacement parts carry the manufacturer's own warranty.`,
    },
  ];
}
